import React from 'react';
import { Inner, Container, Pane, Title, SubTitle, Image  } from '../jumbotron/styles/jumbotron';
import 'normalize.css'

export default function Jumbotron({direction = 'row', children, ...restprops}) {
   return ( 
      <Inner direction = {direction} >
         {children}
      </Inner> 
     
    );
 }

 Jumbotron.Container = function JumbotronContainer({children, ...restprops}){
   return <Container {...restprops }>{children} </Container>;
}
Jumbotron.Pane = function JumbotronPane({children, ...restprops}){
   return <Pane {...restprops }>{children} </Pane>;
}
Jumbotron.Title = function JumbotronTitle({children, ...restprops}){
   return <Title{...restprops }>{children} </Title>;
}
Jumbotron.SubTitle = function JumbotronSubTitle({children, ...restprops}){
   return <SubTitle {...restprops }>{children} </SubTitle>;
}

Jumbotron.Image = function JumbotronImage({ ...restprops}){
   return <Image {...restprops }/>;
}



 